import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Alert } from "@mui/material";
import { axiosRelayInstance } from "../../../../axios";

const CustomSnackbar = ({
  openSnackbar,
  severity,
  message,
  handleClose,
  autoHideDuration = 3000,
  speak,
}) => {
  React.useEffect(() => {
    if (
      openSnackbar &&
      speak &&
      autoHideDuration >= 3000 &&
      severity === "success"
    ) {
      fetch(`${process.env.REACT_RELAY_API_URL}/tts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            axiosRelayInstance.defaults.headers.common.Authorization,
        },
        body: JSON.stringify({ text: message }),
      })
        .then((response) => response.blob())
        .then((blob) => {
          const audio = new Audio(URL.createObjectURL(blob));
          audio.play();
        });
    }
  }, [openSnackbar]);

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
  return (
    <div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={autoHideDuration}
        onClose={handleClose}
        action={action}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={severity}
          sx={{
            width: "100%",
            fontSize: "1rem",
          }}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default CustomSnackbar;
